/** Returns true if `value` is a [[DateRange]] type. */
export function isDateRange(value) {
    // TODO: Check if dates?!
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
//# sourceMappingURL=isDateRange.js.map